export const onCameraFadeout = scene => 
  new Promise(resolve => scene.cameras.main.once('camerafadeoutcomplete', resolve));